import { VisibilityOutlined, VisibilityOffOutlined } from '@mui/icons-material';
import { styled } from '@mui/system';

export const IconVisibility = styled(VisibilityOutlined)(({ theme }) => ({
  color: 'inherit',
}));

export const IconVisibilityOff = styled(VisibilityOffOutlined)(({ theme }) => ({
  color: 'inherit',
}));
